import { types, Instance, SnapshotIn, getRoot } from 'mobx-state-tree';
import { DateTimeType, withDateProcessors } from './DateTimeUtility';
import { DateTime } from 'luxon';
import { luxonUserLocale } from '@farmai-shared/LFUtils';
import { IRootStoreAny } from './rootUtilType';
export const Season = withDateProcessors(types.model({
  id: types.identifier,
  organization_id: types.maybe(types.string),
  name: types.string,
  datetime: DateTimeType,
  endDatetime: DateTimeType,
  country: types.maybeNull(types.string),
  region: types.maybeNull(types.string),
  crop_name: types.maybeNull(types.string),
  crop_name_i18n: types.maybeNull(types.string),
  pending_plantation: types.optional(types.boolean, false),
  status: types.optional(types.string, 'DEFAULT')
}).views(self => ({
  get root() {
    return getRoot<IRootStoreAny>(self);
  }
})).views(self => ({
  get datetimeZ() {
    const lang = self.root.userStore.user.settings.lang;
    return self.datetime.setZone(DateTime.local().zoneName).reconfigure({
      outputCalendar: lang === 'th' ? 'Buddhist' : 'gregory'
    }).setLocale(luxonUserLocale(lang));
  },
  get endDatetimeZ() {
    const lang = self.root.userStore.user.settings.lang;
    return self.endDatetime.setZone(DateTime.local().zoneName).reconfigure({
      outputCalendar: lang === 'th' ? 'Buddhist' : 'gregory'
    }).setLocale(luxonUserLocale(lang));
  }
})));
export type ISeason = Instance<typeof Season>;
export type ISeasonSnapshotIn = SnapshotIn<typeof Season>;
export const SeasonStore = types.model('Season Store', {
  seasons: types.map(Season)
}).actions(self => ({
  pushToSeasons(szn: ISeasonSnapshotIn) {
    return self.seasons.put(szn);
  }
}));